import ReactQuill from 'react-quill';

const Quill = ReactQuill.Quill;
const Font = Quill.import('formats/font');
const Parchment = Quill.import('parchment');
const Delta = Quill.import('delta');
const ClassAttributor = Font.constructor;

export const QUILL_FONT_OPTIONS = [
  'Roboto',
  'Raleway',
  'Montserrat',
  'Lato',
  'Rubik',
  'Source-Sans-Pro',
  'Libre-Baskerville',
  'Merriweather',
  'Playfair-Display',
  'Poppins',
];

Font.whitelist = QUILL_FONT_OPTIONS;
Quill.register(Font, true);

const ListHeadingClass = new ClassAttributor('list-heading', 'ql-list-heading', {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['h1', 'h2', 'h3', 'h4'],
});

Quill.register(ListHeadingClass, true);

export const QUILL_TEXT_FORMATS = ['font', 'list-heading'];

const HEADER_TO_LIST_HEADING = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
};

const BULLET_LINE_REGEX = /^\s*([•●▪◦·\-–—*])\s+(.*)$/;
const ORDERED_LINE_REGEX = /^\s*(\d+)[.)]\s+(.*)$/;

const normalizeListLikePaste = (node, delta) => {
  const text = String(node?.textContent || '')
    .replace(/\u00a0/g, ' ')
    .replace(/\r/g, '')
    .trim();

  if (!text) {
    return delta;
  }

  const bulletMatch = text.match(BULLET_LINE_REGEX);
  if (bulletMatch) {
    return new Delta().insert(bulletMatch[2]).insert('\n', { list: 'bullet' });
  }

  const orderedMatch = text.match(ORDERED_LINE_REGEX);
  if (orderedMatch) {
    return new Delta().insert(orderedMatch[2]).insert('\n', { list: 'ordered' });
  }

  return delta;
};

const preserveHeadingVisualSizeOnList = function preserveHeadingVisualSizeOnList(value) {
  const range = this.quill.getSelection();
  if (!range) {
    this.quill.format('list', value);
    return;
  }

  if (!value) {
    this.quill.format('list', value, 'user');
    this.quill.format('list-heading', false, 'user');
    return;
  }

  const lines = this.quill.getLines(range.index, Math.max(range.length, 1));

  lines.forEach((line) => {
    const lineStart = this.quill.getIndex(line);
    const lineLength = line.length();
    const textLength = Math.max(lineLength - 1, 0);
    const formats = this.quill.getFormat(lineStart, Math.max(textLength, 1));
    const headerLevel = Number(formats.header || 0);

    if (headerLevel) {
      const mappedHeading = HEADER_TO_LIST_HEADING[headerLevel];
      this.quill.formatLine(lineStart, lineLength, 'header', false, 'user');
      this.quill.formatLine(lineStart, lineLength, 'list', value, 'user');
      this.quill.formatLine(lineStart, lineLength, 'list-heading', mappedHeading || false, 'user');
      return;
    }

    this.quill.formatLine(lineStart, lineLength, 'list-heading', false, 'user');
    this.quill.formatLine(lineStart, lineLength, 'list', value, 'user');
  });
};

export const buildQuillModules = (toolbarGroups) => ({
  toolbar: {
    container: [[{ font: QUILL_FONT_OPTIONS }], ...toolbarGroups],
    handlers: {
      list: preserveHeadingVisualSizeOnList,
    },
  },
  clipboard: {
    matchVisual: false,
    matchers: [
      ['p', normalizeListLikePaste],
      ['div', normalizeListLikePaste],
    ],
  },
});
